<header class="main-header">

  <a routerLink="/home" class="logo">
    <div class="logo-mini">
      <img src="./../../../favicon.ico" alt="SIGRP">
    </div>
    <div class="logo-lg">
      <img src="./../../../favicon.ico" alt="SIGRP">
      <span>SIGRP</span>
    </div>
  </a>

  <nav class="navbar navbar-static-top" role="navigation">
    <a href="#" class="sidebar-toggle" data-toggle="offcanvas" role="button">
      <span class="sr-only">Toggle navigation</span>
    </a>

    <div class="navbar-custom-menu" *ngIf="auth.jwtPayload.concedente || auth.jwtPayload.proponente">
      <ul class="nav navbar-nav" *ngIf="auth.jwtPayload?.entidade_nome" >
        <li>
          <a routerLink="/entidade-view/concedente" *ngIf="auth.jwtPayload.concedente">
            <i class="fas fa-building"></i>
            <span>{{ auth.jwtPayload?.entidade_nome }}</span>
          </a>
          <a routerLink="/entidade-view/proponente" *ngIf="auth.jwtPayload.proponente">
            <i class="fas fa-building"></i>
            <span>{{ auth.jwtPayload?.entidade_nome }}</span>
          </a>
        </li>
        <li *ngIf="listaVinculos.length > 1">
          <a href="javascript:void(0)" class="cursor" (click)="abrirModalTrocaEntidade()"
            pTooltip="Trocar unidade" tooltipPosition="bottom">
            <i class="fas fa-sync-alt"></i>
          </a>
        </li>
      </ul>
    </div>

    <div class="navbar-custom-menu">
      <ul class="nav navbar-nav">
        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_NOTIFICACAO')">
          <a [routerLink]="['/notificacao/listar', 'entrada']">
            <i class="far fa-envelope"></i>
            <span class="label label-danger" *ngIf="contadorNotificaoNaoLidas > 0">{{ contadorNotificaoNaoLidas }}</span>
          </a>
        </li>
        <li *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MAPAS')">
          <a routerLink="/mapa">
            <i class="far fa-map"></i>
          </a>
        </li>
        <li>
          <a routerLink="/usuario-view" class="user-chip">
            <span class="user-avatar"><i class="fas fa-user"></i></span>
            <span class="user-meta hidden-xs">
              <span class="user-role">{{ auth.jwtPayload?.perfil }}</span>
              <span class="user-name">{{ auth.jwtPayload?.user_name }}</span>
            </span>
          </a>
        </li>
        <li>
          <a class="cursor btn-logout" (click)="logout()"> <i class="fas fa-sign-out-alt"></i> Sair </a>
        </li>

      </ul>

    </div>
  </nav>
</header>

<!-- MODAL: SELECIONAR UNIDADE/ENTIDADE -->
<p-dialog [style]="{width: '580px'}" header="ENTIDADES VINCULADAS" [visible]="openModalEntidadesView"
  (visibleChange)="onModalEntidadesVisibleChange($event)" showEffect="fade" [modal]="true"
  styleClass="entity-modal">
  <div class="entity-modal-body">
    <div class="entity-modal__header-hint">
      <i class="fa fa-exchange entity-modal__hint-icon"></i>
      <div>
        <p class="entity-modal__hint-title">Selecionar Unidade</p>
        <p class="entity-modal__hint-desc">Escolha a unidade/entidade com a qual deseja trabalhar nesta sessão.</p>
      </div>
    </div>

    <div class="entity-modal__list">
      <button type="button" class="entity-card"
        *ngFor="let item of listaVinculosView"
        [class.entity-card--active]="item.principal"
        (click)="atualizarEntidadePrincipal(item)"
        [disabled]="item.principal">
        <span class="entity-card__status-dot"
          [class.entity-card__status-dot--active]="item.principal"></span>
        <span class="entity-card__icon">
          <i class="fa" [ngClass]="item.entidadeConcedente ? 'fa-institution' : 'fa-building'"></i>
        </span>
        <span class="entity-card__name">
          {{item.entidadeConcedente ? item.entidadeConcedente.nome : item.entidadeProponente.nome}}
        </span>
        <span class="entity-card__badge" *ngIf="item.principal">
          <i class="fa fa-check-circle"></i> Ativa
        </span>
        <i class="fa fa-chevron-right entity-card__arrow" *ngIf="!item.principal"></i>
      </button>
    </div>
  </div>
</p-dialog>